import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import { z } from "zod";
import type { PageSlug} from "./page-slug";
import { pageSlugZodSchema } from "./page-slug";

type PageId = Branded<string, "PageId">;
type PageIdOrSlug = PageId | PageSlug;

const {
    zodSchema: pageIdZodSchema,
    factory: pageIdFactory,
    assert: isPageId,
} = genericId<PageId>("page__");

const pageIdOrSlugZodSchema = z.union([pageIdZodSchema, pageSlugZodSchema]);

export { isPageId, pageIdFactory, pageIdOrSlugZodSchema, pageIdZodSchema };
export type { PageId, PageIdOrSlug };
